module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/operator-6e76801d1b56e419d4fdd311c1d995a8.png";